import React from "react";
import type {DeserializedGridCellParams} from "../MuiXColumnDefinitions.ts";
import {Box, Chip} from "@mui/material";
import {UNCATEGORIZED_VALUE, UNCATEGORIZED_LABEL} from "../../../constants.ts";

export const CategoryL1Cell: React.FC<DeserializedGridCellParams> = (props) => {
    const [expand, setExpand] = React.useState(false)

    if (!props.value) return <></>;
    const uncategorizedReplacedValue = props.value.map(l1 => l1 === UNCATEGORIZED_VALUE ? UNCATEGORIZED_LABEL : l1)

    return <Box className="mt-1">
        {(expand ? uncategorizedReplacedValue : uncategorizedReplacedValue.slice(0, 3)).map(l1 =>
            <Chip
                key={l1}
                label={l1}
                size="small"
                className="me-1 mb-1"
            />)}
        {!expand && (uncategorizedReplacedValue.length > 3) &&
            <Chip
                label={String(uncategorizedReplacedValue.length - 3) + ' more'}
                size="small"
                color="secondary"
                className="mb-1"
                onClick={() => setExpand(true)}
            />}
    </Box>
}
